export default function getExperimentsList(experiments) {
  const list = {};
  experiments.forEach(element => {
    list[element.id] = element.variation;
  });
  return list;
}